import TeamLogo from "src/components/Team/TeamLogo";
import { EventDetails, TeamSummary } from "src/services/miniql";
import styles from "./styles.scss";

function FormattedValue(props: { color?: string | null; value?: string | null }) {
  if (!props.value) {
    return <div>--</div>;
  }

  switch (props.color) {
    case "WLD":
      return (
        <div className="team-summary-item__value">
          {Array.from(props.value).map((letter, i) => {
            switch (letter) {
              case "W":
                return (
                  <span key={i} className="team-summary-item__value--green">
                    {letter}
                  </span>
                );
              case "L":
                return (
                  <span key={i} className="team-summary-item__value--red">
                    {letter}
                  </span>
                );
            }
            return letter;
          })}
        </div>
      );
    case "GREEN":
      return <div className="team-summary-item__value team-summary-item__value--green">{props.value}</div>;
    case "RED":
      return <div className="team-summary-item__value team-summary-item__value--red">{props.value}</div>;
  }

  return <div className="team-summary-item__value">{props.value}</div>;
}

function TeamSummaryItem(props: {
  leagueAbbr: string;
  team: { fullName: string; preferredAbbreviation: string };
  summary: TeamSummary[];
  className: string;
}) {
  return (
    <div className={`team-summary-item ${props.className}`}>
      <div className="team-summary-item__header">
        <TeamLogo
          leagueName={props.leagueAbbr}
          teamAbbreviation={props.team.preferredAbbreviation}
          size={40}
          containerClassName="team-summary-item__logo"
        />
        <div className="team-summary-item__title">{props.team.fullName} Summary</div>
      </div>
      <div className="team-summary-item__mobile-header">
        <TeamLogo
          leagueName={props.leagueAbbr}
          teamAbbreviation={props.team.preferredAbbreviation}
          size={40}
          containerClassName="team-summary-item__logo--mobile"
        />
        <div className="team-summary-item__mobile-header__title">{props.team.preferredAbbreviation}</div>
      </div>
      {props.summary.map((row, i) => (
        <div key={i}>
          <div className={!row.color ? "team-summary-item__key--neutral" : undefined}>{row.name}</div>
          <FormattedValue color={row.color} value={row.value} />
        </div>
      ))}
    </div>
  );
}

export function MiniQLTeamSummary(props: {
  event: {
    league: { name: string };
    homeTeam: { fullName: string; preferredAbbreviation: string };
    awayTeam: { fullName: string; preferredAbbreviation: string };
  };
  eventDetails?: EventDetails;
}) {
  if (!props.eventDetails) {
    return null;
  }

  return (
    <div id="team-summary" className="team-summary__outer-container">
      <div className="team-summary__container">
        <div className="team-summary__header">Team Summary</div>
        <div className="team-summary__items">
          <TeamSummaryItem
            leagueAbbr={props.event.league.name}
            team={props.event.awayTeam}
            summary={props.eventDetails.awayTeam.summary}
            className="team-summary-item--left"
          />
          <TeamSummaryItem
            leagueAbbr={props.event.league.name}
            team={props.event.homeTeam}
            summary={props.eventDetails.homeTeam.summary}
            className="team-summary-item--right"
          />
        </div>
      </div>
      <style jsx global>
        {styles}
      </style>
    </div>
  );
}
